export const firebaseMarkerToMarker = (firebaseMarker: any) => {
  return {
    ...firebaseMarker,
    coordinate: {
      lat: firebaseMarker?.coordinate?.latitude,
      lng: firebaseMarker?.coordinate?.longitude,
    },
  };
};
